/* L5 Menü (12.10.2026): Ergänzungen zu Stiletto theme.js, ohne Bibliothek.
   1. Desktop: Esc in einem offenen Dropdown/Mega-Menü schließt es (Stiletto) und gibt den Fokus an den Menüpunkt zurück,
      ohne dass das Menü durch den Fokus sofort wieder aufgeht.
   2. Mobil: Drill-down im Drawer (snippets/gw-drawer-menu.liquid): Unterseite einschieben, Zurück, Schließen,
      Fokus führen, beim Schließen des Drawers zurücksetzen. prefers-reduced-motion: ohne Animation.
   3. Footer-Akkordeon (mobil): aria-expanded am Stiletto-Knopf mitführen. */
(function () {
  'use strict';
  var bewegungAus = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function ohneAnimation() { return !!(bewegungAus && bewegungAus.matches); }

  /* 1. Desktop: Fokus nach Esc zurück */
  var unterdruecke = null;
  document.addEventListener('focus', function (e) {
    if (unterdruecke && e.target === unterdruecke) { e.stopPropagation(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var a = document.activeElement;
    if (!a || !a.closest) return;
    var panel = a.closest('.header__links-primary [data-submenu]');
    if (!panel || !panel.id) return;
    var ausloeser = document.querySelector('.header__links-primary [aria-controls="' + panel.id + '"]');
    if (!ausloeser) return;
    unterdruecke = ausloeser;
    ausloeser.focus();
    ausloeser.setAttribute('aria-expanded', 'false');
    setTimeout(function () { unterdruecke = null; }, 0);
  });

  /* 1a. Desktop: aria-expanded am Auslöser = Zustand des Panels (13.10.). Stiletto setzt es beim Mega-Menü (Wasserpflege) per
     Tastatur sofort wieder auf false (closeAll im Fokus-Handler der Menüzeile), obwohl das Panel offen bleibt. Hier wird nach
     jedem Ereignis und jeder Klassenänderung am Panel der Wert aus dem Panel-Zustand abgeleitet; Hover-Brücke/250 ms bleiben. */
  var hauptnav = document.querySelector('.header__links-primary');
  if (hauptnav) {
    var angleichen = function () {
      var ausl = hauptnav.querySelectorAll('[data-link][aria-controls]');
      for (var j = 0; j < ausl.length; j++) {
        var pn = document.getElementById(ausl[j].getAttribute('aria-controls'));
        if (!pn) continue;
        var an = pn.classList.contains('active') ? 'true' : 'false';
        if (ausl[j].getAttribute('aria-expanded') !== an) ausl[j].setAttribute('aria-expanded', an);
      }
    };
    var verzoegert = function () { setTimeout(angleichen, 0); };
    ['focusin', 'focusout', 'keydown', 'mouseover', 'mouseout', 'click'].forEach(function (typ) {
      document.addEventListener(typ, verzoegert, true);
    });
    var beobachter = new MutationObserver(angleichen);
    var panels = document.querySelectorAll('.header [data-submenu], .header .meganav');
    for (var k = 0; k < panels.length; k++) beobachter.observe(panels[k], { attributes: true, attributeFilter: ['class'] });
  }

  /* 1b. Desktop: Schließverzögerung 250 ms (Hugo 13.10.). Stiletto schließt Dropdown/Mega-Menü sofort, wenn die Maus die
     Menüzeile verlässt (mouseout an der Zeile) oder die Seiten-Abdunklung berührt (mouseover .header-overlay__inner); eine
     Option für eine Verzögerung bringt Stiletto nicht mit. Beide Ereignisse werden hier abgefangen und nach 250 ms erneut
     ausgelöst, falls die Maus dann nicht wieder über Menüzeile oder Panel ist. Tastatur/Esc sind nicht betroffen. */
  var nav = document.querySelector('.header__links-primary');
  var zeile = nav && nav.closest('.header__row');
  if (zeile) {
    var timer = null, echt = false;
    var drueber = function () { return zeile.matches(':hover'); };
    var spaeter = function (ziel, typ) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (drueber()) return;
        echt = true;
        try { ziel.dispatchEvent(new MouseEvent(typ, { bubbles: true, relatedTarget: document.body })); } finally { echt = false; }
      }, 250);
    };
    document.addEventListener('mouseout', function (e) {
      if (echt || window.innerWidth < 960 || !zeile.contains(e.target)) return;
      var rt = e.relatedTarget;
      if (rt && rt.closest && rt.closest('.header__row') === zeile) return;
      e.stopPropagation();
      spaeter(zeile, 'mouseout');
    }, true);
    document.addEventListener('mouseover', function (e) {
      if (echt || window.innerWidth < 960 || !e.target.closest) return;
      var ov = e.target.closest('.header-overlay__inner');
      if (ov) { e.stopPropagation(); spaeter(ov, 'mouseover'); return; }
      if (zeile.contains(e.target)) clearTimeout(timer);
    }, true);
  }

  /* 2. Mobil: Drill-down */
  var dm = document.querySelector('[data-gw-dm]');
  if (dm) {
    var unten = dm.querySelector('.gw-dm-unten');
    var offen = null;

    var zeigen = function (knopf) {
      var p = document.getElementById(knopf.getAttribute('aria-controls'));
      if (!p) return;
      offen = { p: p, k: knopf };
      knopf.setAttribute('aria-expanded', 'true');
      p.hidden = false;
      p.scrollTop = 0;
      void p.offsetWidth;
      p.classList.add('gw-ist-offen');
      unten.classList.add('gw-ist-tief');
      var zur = p.querySelector('[data-gw-dm-zurueck]');
      if (zur) zur.focus({ preventScroll: true });
    };

    var zurueck = function (fokusZurueck) {
      if (!offen) return;
      var p = offen.p, k = offen.k;
      offen = null;
      k.setAttribute('aria-expanded', 'false');
      unten.classList.remove('gw-ist-tief');
      p.classList.remove('gw-ist-offen');
      var weg = function () { if (!p.classList.contains('gw-ist-offen')) p.hidden = true; };
      if (ohneAnimation() || !fokusZurueck) { weg(); } else { setTimeout(weg, 320); }
      if (fokusZurueck) k.focus({ preventScroll: true });
    };

    dm.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-gw-dm-auf],[data-gw-dm-zurueck],[data-gw-dm-zu]') : null;
      if (!t) return;
      e.preventDefault();
      if (t.hasAttribute('data-gw-dm-auf')) { zeigen(t); return; }
      if (t.hasAttribute('data-gw-dm-zurueck')) { zurueck(true); return; }
      var m = document.querySelector('[data-js-menu-button][aria-expanded="true"]') || document.querySelector('[data-js-menu-button]');
      if (m) m.click();
    });

    // Drawer geschlossen (Stiletto setzt body[mobile-menu-open="false"]) → Unterseite zurücksetzen
    new MutationObserver(function () {
      if (document.body.getAttribute('mobile-menu-open') === 'false') {
        setTimeout(function () { zurueck(false); }, 360);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['mobile-menu-open'] });
  }

  /* 3. Footer-Akkordeon: aria-expanded */
  var fk = document.querySelectorAll('.footer__group--collapse button[data-header]');
  for (var i = 0; i < fk.length; i++) {
    fk[i].addEventListener('click', function (e) {
      var b = e.currentTarget;
      setTimeout(function () { b.setAttribute('aria-expanded', b.classList.contains('open') ? 'true' : 'false'); }, 0);
    });
  }
})();
